<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="100px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="ID">
            {{ form.appId }}
          </el-form-item>
          <el-form-item label="企业名称">
            {{ form.title }}
          </el-form-item>
          <el-form-item label="联系电话" prop="tel">
            <el-input
              class="fix-width"
              v-model="form.tel"
              placeholder="请输入联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
              class="fix-width"
              v-model="form.address"
              placeholder="请输入企业地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="经度" prop="longitude">
            <el-input
              class="fix-width"
              v-model="form.longitude"
              placeholder="请输入经度"
            ></el-input>
          </el-form-item>
          <el-form-item label="纬度" prop="latitude">
            <el-input
              class="fix-width"
              v-model="form.latitude"
              placeholder="请输入纬度"
            ></el-input>
          </el-form-item>
          <el-form-item label="背景图片" prop="backgroundImage">
            <el-upload
              :action="QNUploadURL"
              :data="uploadToken"
              :limit="1"
              :multiple="false"
              :before-upload="beforeAvatarUpload"
              class="avatar-uploader"
              :on-success="handleAvatarSuccess"
              :on-remove="image_remove"
              :show-file-list="false"
            >
              <img
                v-if="form.backgroundImage"
                class="avatar"
                :src="form.backgroundImage"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span>建议尺寸 750px * 600px</span>
          </el-form-item>
          <el-form-item label="企业简介" prop="backgroundImage">
            <el-input
              type="textarea"
              v-model="form.text"
              rows="10"
              placeholder="请输入企业简介"
            ></el-input>
          </el-form-item>
          <el-form-item label="通知声音提醒">
            <el-switch
              v-model="isOpenAudio"
              active-text="开启"
              inactive-text="关闭"
              @change="audioChange"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getApp, setupConfig, getConfig } from '@/api/settings'
import { QNUploadURL, QNHost } from '@/config/net.config'
import { getUploadToken } from '@/api/app'
import storejs from 'store'
export default {
  name: 'SettingsBasic',
  data() {
    return {
      QNUploadURL,
      uploadToken: '',
      labelPosition: 'right',
      form: {
        appId: '',
        title: '',
        backgroundImage: '',
        text: '',
        address: '',
        latitude: '',
        longitude: '',
        tel: '',
      },
      rules: {},
      isOpenAudio: false,
    }
  },
  async mounted() {
    this.getData()
    this.isOpenAudio = storejs.get('isOpenAudio') || false
    const token = await getUploadToken({})
    this.uploadToken = { token: token.token }
  },
  methods: {
    audioChange(val) {
      storejs.set('isOpenAudio', val)
    },
    handleAvatarSuccess(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.backgroundImage = QNHost + '/' + res.hash
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    async getData() {
      const ret = await getApp()
      const config = await getConfig({ key: 'BASIC' })
      this.form.appId = ret.appId
      this.form.title = ret.title
      this.form.backgroundImage = config.basic.backgroundImage
      this.form.text = config.basic.text
      this.form.address = config.basic.address
      this.form.latitude = config.basic.latitude
      this.form.longitude = config.basic.longitude
      this.form.tel = config.basic.tel
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const config = await setupConfig({
            key: 'BASIC',
            backgroundImage: this.form.backgroundImage,
            text: this.form.text,
            address: this.form.address,
            latitude: this.form.latitude,
            longitude: this.form.longitude,
            tel: this.form.tel,
          })
          this.$message.success('保存基本信息配置成功')
        } else {
          this.$message.success('保存基本信息配置失败')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.fix-width {
  width: 500px;
}
::v-deep {
  .el-form-item__content {
    .el-rate {
      display: inline-block;
      font-size: 0;
      line-height: 1;
      vertical-align: middle;
    }

    .el-transfer__buttons {
      padding: 10px 10px 0 10px;
    }
  }
}
:deep(.el-upload) {
  border: 1px dashed #81878f;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.job-avatar {
  width: 335px;
  height: 252px;
  display: block;
}
</style>
